import {clsx} from 'clsx';

interface Props {
  formStyle?: 'sm' | null | undefined;
}

export function useEvFormInputClass(props: Props): string {
  const formStyleSm = props.formStyle === 'sm';
  return clsx(
    {
      'rounded-sm': !formStyleSm,
      'h-8': !formStyleSm,
      'pt-5': !formStyleSm,
      'pr-3': !formStyleSm,
      'pb-5': !formStyleSm,
      'pl-3': !formStyleSm,
      'text-bs-form-control': !formStyleSm,
      'leading-bs-form-control!': !formStyleSm,

      'pt-1.5': formStyleSm,
      'pr-2.5': formStyleSm,
      'pb-1.5': formStyleSm,
      'pl-2.5': formStyleSm,
      'text-sm': formStyleSm,
      'text-bs-form-control-sm!': formStyleSm,
      'leading-bs-form-control-sm!': formStyleSm,
    },
    'outline-0',
    'block',
    'border',
    'border-solid',
    'bg-white',
    'text-bs-form-control-text',
    'leading-bs-form-control!',
    'border-bs-form-control-border',
    'focus:border-bs-form-control-focus-border',
    'hover:border-bs-form-control-focus-border',
    'inset-shadow-bs-form-control',
    'focus:shadow-bs-form-control-hover',
    'hover:shadow-bs-form-control-hover',
    'disabled:cursor-not-allowed',
    'disabled:bg-bs-form-control-disabled-background',
    'disabled:shadow-none',
    'transition ease-in-out delay-150',
    'w-full',
  );
}
